import { styled } from '@mui/material/styles';

export const LinearLoader = styled('div')<{ displayTime: number }>(({ theme, displayTime }) => ({
  height: 2,
  backgroundColor: theme.palette.blue[500],
  animation: `Loader ${displayTime}ms linear`,
  borderRadius: 8,

  '@keyframes Loader': {
    '0%': {
      width: 0,
      height: 2,
    },
    '100%': {
      width: '100%',
      height: 2,
    },
  },
}));

export const LoaderBg = styled('div')(
  ({ theme }) => `
  flex: 1;
  height: 2px;
  margin-left: ${theme.spacing(1)};
  margin-right: ${theme.spacing(1)};
  background-color: ${theme.palette.blue[75]};
  border-radius: 8px;
`
);

export const LoadedBg = styled(LoaderBg)(
  ({ theme }) => `
  background-color: ${theme.palette.blue[500]};
`
);

export const LoadersRow = styled('div')(
  ({ theme }) => `
  position: fixed;
  display: flex;
  flex: 1;
  flex-direction: row;
  top: ${theme.spacing(0.5)};

  @media (max-width: ${theme.breakpoints.values.sm}px) {
    left: ${theme.spacing(4)};
    right: ${theme.spacing(4)};
  }

  @media (min-width: ${theme.breakpoints.values.sm}px) {
    width: calc(${theme.breakpoints.values.sm}px - ${theme.spacing(8)});
    left: calc((100vw - ${theme.breakpoints.values.sm}px) / 2 + ${theme.spacing(4)});
  }
`
);

export const TransparentBox = styled('div')`
  position: absolute;
  display: flex;
  flex-direction: row;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
`;

export const Swiper = styled('div')<{ toLeft: boolean }>(({ theme, toLeft }) => ({
  animation: `${toLeft ? ' SwipeToLeft' : 'SwipeToRight'} 300ms ease-out`,

  [`@media(min-width: ${theme.breakpoints.values.sm}px)`]: {
    minHeight: '408px',
  },

  '@keyframes SwipeToLeft': {
    '0%': {
      transform: 'translateX(100%)',
    },
    '100%': {
      transform: 'translateX(0)',
    },
  },

  '@keyframes SwipeToRight': {
    '0%': {
      transform: 'translateX(-100%)',
    },
    '100%': {
      transform: 'translateX(0)',
    },
  },
}));
